export default __webpack_public_path__ + "static/media/photo--lg--misc-8.e50bdc20.jpg";